import { Component, OnInit } from '@angular/core';
import { fciWebsiteService } from '../../../service/fci-website.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { environment } from 'src/environments/environment';
declare let $: any;
import * as CryptoJS from "crypto-js";
import { Buffer } from 'buffer';
import { EncryptDecryptService } from '../../../service/encrypt-decrypt.service';
import { ActivatedRoute, Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';
import { CustomServiceService } from '../../../service/custom-service.service';
@Component({
  selector: 'app-social-media',
  templateUrl: './social-media.component.html',
  styleUrls: ['./social-media.component.css']
})
export class SocialMediaComponent implements OnInit {

  constructor(private fciwebservice: fciWebsiteService, private encDec: EncryptDecryptService, public translate: TranslateService, private httpservice: CustomServiceService,private route: Router) { }
  imageUrl = environment.serviceURL + 'storage/app/uploads/';
  backendUrl = environment.serviceURL
  CURRENT_ZONE_ID: any = environment.ZONE_ID;
  CURRENT_REGION_ID: any = environment.REGION_ID;
  CURRENT_ZONE_CODE: any = environment.ZONE_CODE;
  CURRENT_REGION_CODE: any = environment.REGION_CODE;
  language: any = '';
  datetime: any = this.httpservice.currentDateTime();
  ngOnInit(): void {

    this.language = sessionStorage.getItem('locale'); //dynamic content language translation 

    // FOR PHOTO GALLERY AND VIDEO GALLERY - STARTS
    // setTimeout(() => {
    //   $('#gallery-container').lightGallery();
    // }, 2000);

    // setTimeout(() => {
    //   $('#video-container').lightGallery();
    // }, 2000);
    // FOR PHOTO GALLERY AND VIDEO GALLERY - ENDS
    // this.getAllPhotos();
    // this.getAllVideos();'

    // this.getGalleryCat();
    // this.getVideoCat(); 
  }

  designArr = ['col-xxl-2 col-xl-4 col-lg-4 col-md-6 col-6 gallery-item mb-2 mb-md-4', 'col-xxl-4 col-xl-2 col-lg-4 col-md-6 col-6 gallery-item mb-2 mb-md-4', 'col-xxl-2 col-xl-4 col-lg-4 col-md-6 col-6 gallery-item mb-2 mb-md-4', 'col-xxl-4 col-xl-2 col-lg-4 col-md-6 col-6 gallery-item mb-2 mb-md-4', 'col-xxl-4 col-xl-2 col-lg-4 col-md-6 col-6 gallery-item mb-2 mb-md-4', 'col-xxl-2 col-xl-4 col-lg-4 col-md-6 col-6 gallery-item mb-2 mb-md-4', 'col-xxl-4 col-xl-2 col-lg-4 col-md-6 col-6 gallery-item mb-2 mb-md-4', 'col-xxl-2 col-xl-4 col-lg-4 col-md-6 col-6 gallery-item mb-2 mb-md-4'];
  content_apiresponse: any;
  gallery: any;
  videogallery: any;
  galleryCat: any = [];
  getAllPhotos() {
    let params = [{
      "secSlNo": 1,
      "offSet": 0,
      "noOfRecords": 8,
      "orderBy": [{ "columnName": "intId", "type": "DESC" }],
      "condition": [
        { "columnName": "UPLOAD_TYPE", "operator": "=", "value": '1', "joinoperator": "and" },
        { "columnName": "bitDeletedFlag", "operator": "=", "value": 0, "joinoperator": "and" },
        { "columnName": "tinPublishStatus", "operator": "=", "value": 1, "joinoperator": "and" }
      ],
      "viewParameters": ""
    }];
    this.fciwebservice.getPhotoGallery(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.content_apiresponse = response.body;
          let respData = this.content_apiresponse.RESPONSE_DATA;
          let respToken = this.content_apiresponse.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData, environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let response_: any = Buffer.from(respData, 'base64');
            response_ = JSON.parse(response_);
            this.gallery = response_.result.sec_1;

          }
      }
    });

  }


  getAllVideos() {
    let params = [{
      "secSlNo": 1,
      "offSet": 0,
      "noOfRecords": 8,
      "orderBy": [{ "columnName": "intId", "type": "DESC" }],
      "condition": [
        // {"columnName":"VCHMEDIATYPE","operator":"=","value":2,"joinoperator":"and"},
        { "columnName": "bitDeletedFlag", "operator": "=", "value": 0, "joinoperator": "and" },
        { "columnName": "tinPublishStatus", "operator": "=", "value": 1, "joinoperator": "and" }
      ],
      "viewParameters": ""
    }];
    this.fciwebservice.getPhotoGallery(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.content_apiresponse = response.body;
          let respData = this.content_apiresponse.RESPONSE_DATA;
          let respToken = this.content_apiresponse.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData, environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let response: any = Buffer.from(respData, 'base64');
            response = JSON.parse(response);
            this.videogallery = [];
            this.videogallery = response.result.sec_1;
          }
      }
    });

  }

  totalgalleryCat: number = 0;
  checkPhotobuttonclick: boolean = false;
  getGalleryCat() {
    let params:any;
    params = {
      limit:8,
      "ARCHIVEDATE": this.datetime.date,
      "ARCHIVE_DATE_type": ">",
      MEDIATYPE:1,
      ZONE_ID:environment.ZONE_ID,
      REGION_ID:environment.REGION_ID
    };
    if (!this.checkPhotobuttonclick) {
      this.checkPhotobuttonclick = true;
      this.fciwebservice.countvideophoto(params, 'api/home-photos-videos-list').subscribe((response: HttpEvent<any>) => {
        switch (response.type) {
          case HttpEventType.Sent:
            //console.log('Sent' + HttpEventType.Sent);
            break;
          case HttpEventType.ResponseHeader:
            //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
            break;
          case HttpEventType.UploadProgress:
            //this.evenTotal = response.total;
            //this.progress = Math.round(response.loaded / this.evenTotal * 100);
            break;
          case HttpEventType.Response:
            this.content_apiresponse = response.body;
            let respData = this.content_apiresponse.RESPONSE_DATA;
            let respToken = this.content_apiresponse.RESPONSE_TOKEN;
            let verifyToken = CryptoJS.HmacSHA256(respData, environment.apiHashingKey).toString();
            if (respToken == verifyToken) {
              let response: any = Buffer.from(respData, 'base64');
              response = JSON.parse(response);
              // console.log(response);
              this.galleryCat = [];
              this.galleryCat = response.dataList;
              this.totalgalleryCat = response.noOfRec;
             
              // console.log(this.galleryCat,this.totalgalleryCat);
              // setTimeout(() => {
              //   $('#gallery-container').lightGallery();
              // }, 500)

            }
        }
      });
    }

  }

  totalVideoCat: number = 0;
  VideoCat: any =[];
  checkVideobuttonclick: boolean = false;
  getVideoCat() {
    let params:any;
    params = {
      limit:8,
      "ARCHIVEDATE": this.datetime.date,
      "ARCHIVE_DATE_type": ">",
      MEDIATYPE:2,
      ZONE_ID:environment.ZONE_ID,
      REGION_ID:environment.REGION_ID
    };
    if (!this.checkVideobuttonclick) {
      this.checkVideobuttonclick = true;
      this.fciwebservice.countvideophoto(params, 'api/home-photos-videos-list').subscribe((response: HttpEvent<any>) => {
        switch (response.type) {
          case HttpEventType.Sent:
            //console.log('Sent' + HttpEventType.Sent);
            break;
          case HttpEventType.ResponseHeader:
            //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
            break;
          case HttpEventType.UploadProgress:
            //this.evenTotal = response.total;
            //this.progress = Math.round(response.loaded / this.evenTotal * 100);
            break;
          case HttpEventType.Response:
            this.content_apiresponse = response.body;
            let respData = this.content_apiresponse.RESPONSE_DATA;
            let respToken = this.content_apiresponse.RESPONSE_TOKEN;
            let verifyToken = CryptoJS.HmacSHA256(respData, environment.apiHashingKey).toString();
            if (respToken == verifyToken) {
              let response: any = Buffer.from(respData, 'base64');
              response = JSON.parse(response);
              // console.log(response);
              this.VideoCat = [];
              this.VideoCat = response.dataList;
              this.totalVideoCat = response.noOfRec;
              // setTimeout(() => {
              //   $('#video-container').lightGallery();
              // }, 500)
            }
        }
      });
    }

  }
  htmldecode(str: any) {
    return this.encDec.decodeHtml(str);
  }

  viewDetails(id: any, pageName: any) {
    let encSchemeStr = this.encDec.encText(id.toString());
    this.route.navigate(['./' + pageName + '/', encSchemeStr]);
  }
}
